<template>
  <span class="block text-sm font-medium pb-0.5" data-testid="form-label">
    <slot />
  </span>
</template>
